import React from 'react'
import styled from 'styled-components'
import { Box, P, IconContainer, H3 } from '@allied-solutions/affinity'
import { Bank } from '@allied-solutions/affinity-react-icons/standard'
import { LoanInformationRow } from './LoanInformationRow'

const StyledLoanInformationBox = styled(Box)`
  & > :last-child {
    border-bottom: none;
  }
`

const maskLoanNumber = value => {
  if (value == null) return value
  const str = String(value)
  if (str.length <= 4) return str
  return '•'.repeat(str.length - 4) + str.slice(-4)
}

export const DashboardTileLoanInformation = ({ borrowerData }) => {
  return (
    <>
      <Box display="flex" alignItems="center" gap="lg" mb="4xl">
        <IconContainer icon={Bank} color="brand" />
        <H3 typeStyle="titleSmall" textAlign="left" fontWeight="700" mb="0">
          Loan Information
        </H3>
      </Box>
      <Box>
        <StyledLoanInformationBox
          p="4xl"
          border="1px solid"
          borderColor="border.defaultLight"
          borderRadius="2"
          className="loan-information-box"
        >
          <LoanInformationRow label="Lender">
            <P typeStyle="bodyMedium" color="text.secondary" mb="0">
              {borrowerData?.LenderName}
            </P>
          </LoanInformationRow>
          <LoanInformationRow label="Loan Number">
            <P typeStyle="bodyMedium" color="text.secondary" mb="0">
              {maskLoanNumber(borrowerData?.PolicyNumber)}
            </P>
          </LoanInformationRow>
          <LoanInformationRow label="Borrower">
            <P
              typeStyle="bodyMedium"
              color="text.secondary"
              mb="xs"
            >{`${borrowerData?.PolicyholderFirstName} ${borrowerData?.PolicyholderLastName}`}</P>
            <P typeStyle="bodyMedium" color="text.secondary" mb="xs">
              {borrowerData?.PolicyholderAddress1}
            </P>
            <P
              typeStyle="bodyMedium"
              color="text.secondary"
              mb="xs"
            >{`${borrowerData?.PolicyholderCity}, ${borrowerData?.PolicyholderState} ${borrowerData?.PolicyholderZip}`}</P>
          </LoanInformationRow>
          {borrowerData?.AdditionalOwners?.length > 0 && (
            <LoanInformationRow label="Co-Borrowers" isLast>
              <Box display="flex" flexDirection="column" alignItems="flex-end">
                {borrowerData.AdditionalOwners.map(owner => (
                  <P
                    key={owner.FirstName + owner.LastName}
                    typeStyle="bodyMedium"
                    textAlign="right"
                    color="text.secondary"
                    mb="0"
                  >
                    {owner.FirstName} {owner.LastName}
                  </P>
                ))}
              </Box>
            </LoanInformationRow>
          )}
        </StyledLoanInformationBox>
      </Box>
    </>
  )
}
